import { useState, Fragment } from "react";
import { uploadFile } from "../../services/Base/base-service";

import {
  Alert,
  Input,
  InputGroup,
  Button,
  FormGroup,
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "design-react-kit";

const ExternalFlowSignUploadModal = ({
  modalOpen,
  modalCloseHandler,
  externalFlow,
}) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const closeModalHandler = () => {
    document.getElementById("file-form").reset();
    setFile(null);
    modalCloseHandler();
  };

  const uploadCompletedHandler = (response) => {
    if (response.errors !== null) {
      setError(response.errors);
    } else {
      closeModalHandler();
    }
    setIsLoading(false);
  };

  const uploadExternalFlowHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    uploadFile(
      file,
      {
        externalFlowId: externalFlow.id,
      },
      "ExternalFlow/UploadZipWithSignature",
      uploadCompletedHandler
    );
  };

  return (
    <Fragment>
      <Modal
        isOpen={modalOpen}
        labelledBy="externalflowUploadSign"
        toggle={closeModalHandler}
        align="center"
        keyboard={isLoading ? false : true}
      >
        <ModalHeader id="externalflowUploadSign" toggle={closeModalHandler}>
          <h6 className="text-capitalize text-center">
            {externalFlow?.zipWithSignatureFileName === null
              ? "Carica"
              : "Ricarica"}{" "}
            file PDF firmati digitalmente (PAdES)
          </h6>
        </ModalHeader>
        <ModalBody>
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mb-5">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          <div className="form-row">
            <FormGroup className="col-sm-12 m-0 mt-2 mb-3 position-relative">
              <div>
                <div className="col-12">
                  <h5>
                    Nome atteso per file (ZIP) da caricare:{" "}
                    <span style={{ color: "#0073e6" }}>
                      {externalFlow?.zipFileName.replace(
                        ".zip",
                        "-PdfFirmati.zip"
                      )}
                    </span>
                  </h5>
                </div>
                <div className="col-12">
                  <h5 className="text-capitalize">
                    Tipologia Servizio:{" "}
                    <span style={{ color: "#0073e6 " }}>
                      {externalFlow?.clientCode}
                    </span>
                  </h5>
                </div>
              </div>
              {externalFlow?.zipWithSignatureFileName !== null && (
                <div>
                  <div className="col-12">
                    <h5>
                      ZIP con firme:{" "}
                      <span style={{ color: "#0073e6 " }}>
                        {externalFlow?.zipWithSignatureFileName}
                      </span>
                    </h5>
                  </div>
                </div>
              )}
            </FormGroup>
          </div>
          <div className="form-row">
            <InputGroup className="col-sm-12 m-0 mb-4 align-items-center">
              <form id="file-form" className="col-sm-12 m-0">
                <label
                  htmlFor="file"
                  role="button"
                  className="btn-secondary rounded p-2 mr-2"
                >
                  Scegli file da caricare
                </label>
                <Input
                  className="btn"
                  id="file"
                  type="file"
                  style={{ display: "none" }}
                  accept="application/zip"
                  onClick={() => document.getElementById("file-form").reset()}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setError(null);
                    if (file !== undefined && file !== null) {
                      if (file.type !== "application/zip") {
                        setFile(file);
                      } else {
                        setFile(null);
                        setError([<p>Il file scelto non è uno "zip"!</p>]);
                      }
                    }
                  }}
                />
                <span>
                  {file === null ? "Nessun file scelto" : `${file?.name}`}
                </span>
              </form>
            </InputGroup>
          </div>
          <FormGroup className="col-sm-12 mb-3 d-flex align-items-center justify-content-end">
            <Button
              id="user-cancel"
              color="white"
              className="mr-2"
              onClick={closeModalHandler}
            >
              Annulla
            </Button>
            <Button
              disabled={file === null}
              style={{
                backgroundColor: "#5EB423",
                color: "#fff",
                padding: "7px 15px",
              }}
              id="external-flow-upload"
              type="submit"
              onClick={(e) => uploadExternalFlowHandler(e)}
            >
              <Icon icon="it-check" fill="#ffffff" /> Carica file
            </Button>
          </FormGroup>
        </ModalBody>
      </Modal>
      {isLoading && (
        <div className="modal_backdrop">
          <div className="position-relative upload-spinner">
            <p style={{ height: "50px", marginBottom: "7rem" }}>
              <Spinner double active />
            </p>
            <h3 style={{ color: "#fff" }}>
              Attendere prego, caricamento in corso...
            </h3>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default ExternalFlowSignUploadModal;
